import { theme } from 'antd';
import { studioDarkAlgorithm } from "./darkAlgorithm";
export var createStudioAntdTheme = function createStudioAntdTheme(appearance) {
  var themeConfig = {
    algorithm: [theme.compactAlgorithm]
  };
  if (appearance === 'dark') {
    themeConfig.algorithm.push(studioDarkAlgorithm);
  }
  return themeConfig;
};